import { createSlice } from '@reduxjs/toolkit'

export const contextSlice = createSlice({
  name: 'context',
  initialState: {
    menuKey: '',
    breadcrumb1: '',
    breadcrumb2: '',
    breadcrumb3: '',
    breadcrumb1_href: '',
    breadcrumb2_href: '',
    breadcrumb3_href: '',
    currentRoute: '',
    toolCategoryTabKey: 'tools'
  },
  reducers: {
    updateMenuKey: (state, action) => {
      state.menuKey = action.payload.menuKey;
    },

    updateBreadcrumb: (state, action) => {
      state.breadcrumb1 = action.payload.breadcrumb1;
      state.breadcrumb2 = action.payload.breadcrumb2;
      state.breadcrumb3 = action.payload.breadcrumb3;
      state.breadcrumb1_href = action.payload.breadcrumb1_href;
      state.breadcrumb2_href = action.payload.breadcrumb2_href;
      state.breadcrumb3_href = action.payload.breadcrumb3_href;
    },

    updateCurrentRoute: (state, action) => {
      state.currentRoute = action.payload.currentRoute;
    },

    updateToolCategoryTabKey: (state, action) => {
      state.toolCategoryTabKey = action.payload.toolCategoryTabKey;
    },
  },
});

export const { updateMenuKey, updateBreadcrumb, updateCurrentRoute, updateToolCategoryTabKey } = contextSlice.actions;

export default contextSlice.reducer
